/**
 * Formatting and state-normalisation helpers for the payment detail mapper.
 */
import { FlowState, Direction } from './paymentDetailTypes';

const parse = (iso?: string | null): Date | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** ISO → "YYYY-MM-DD HH:mm:ss UTC"; '—' when missing, raw string when unparseable. */
export const fullTimestamp = (iso?: string | null): string => {
  if (!iso) return '—';
  const date = parse(iso);
  return date ? `${date.toISOString().substring(0, 19).replace('T', ' ')} UTC` : iso;
};

/** "OUTBOUND" → "Outbound". */
export const titleCase = (value: string): string => value.charAt(0) + value.slice(1).toLowerCase();

export const toDirection = (value?: string | null): Direction =>
  (value ?? '').toUpperCase() === 'INBOUND' ? 'INBOUND' : 'OUTBOUND';

/** Backend state vocabulary → the UI's five FlowStates. */
export const toFlowState = (state?: string | null): FlowState => {
  switch ((state ?? '').toUpperCase()) {
    case 'SUCCESS':
    case 'SUCCEEDED':
    case 'COMPLETED':
    case 'SETTLED':
    case 'NOT_HELD': // OUTAGE check passed — payment was not held
      return 'SUCCESS';
    case 'FAILED':
    case 'FAILURE':
    case 'ERROR':
    case 'REJECTED':
      return 'FAILED';
    case 'RECEIVED':
      return 'RECEIVED';
    case 'HELD': // OUTAGE check held the payment
    case 'IN_OUTAGE':
    case 'OUTAGE':
      return 'IN_OUTAGE';
    default:
      return 'PROCESSING';
  }
};
